import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import {
  productsControllerCreate,
  ProductsControllerCreate$Params,
  productsControllerDelete,
  productsControllerFindAll,
  ProductsControllerFindAll$Params,
  productsControllerGetDeletionImpact,
  productsControllerUpdate,
  ProductsControllerUpdate$Params,
} from '@klubovna/api-client';
import { CreateProductDto, DeleteProductDto, DeletionImpactDto, Product, UpdateProductDto } from '@klubovna/api-client';
import { PaginatedResponse, toPaginatedResponse } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProductsApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  findAll(params?: ProductsControllerFindAll$Params): Observable<PaginatedResponse<Product>> {
    return productsControllerFindAll(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => toPaginatedResponse<Product>(response.body)));
  }

  create(productData: CreateProductDto): Observable<Product> {
    const params: ProductsControllerCreate$Params = {
      body: productData,
    };
    return productsControllerCreate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as Product));
  }

  update(id: string, productData: UpdateProductDto): Observable<Product> {
    const params: ProductsControllerUpdate$Params = {
      id,
      body: productData,
    };
    return productsControllerUpdate(this.http, this.apiConfig.rootUrl, params)
      .pipe(map(response => response.body as Product));
  }

  getDeletionImpact(id: string): Observable<DeletionImpactDto> {
    return productsControllerGetDeletionImpact(this.http, this.apiConfig.rootUrl, { id })
      .pipe(map(response => response.body));
  }

  delete(id: string, body?: DeleteProductDto): Observable<void> {
    return productsControllerDelete(this.http, this.apiConfig.rootUrl, { id, body: body ?? {} as DeleteProductDto })
      .pipe(map(() => undefined));
  }
}
